export const popularLanguages = [
    "English",
    "Mandarin Chinese",
    "Spanish",
    "Hindi",
    "Arabic",
    "Portuguese",
    "Bengali",
    "Russian",
    "Japanese",
    "Punjabi",
    "German",
    "French",
    "Korean",
    "Italian",
    "Turkish",
    "Vietnamese",
    "Urdu",
    "Swahili",
    "Persian (Farsi)",
    "Malay"
];

export const GENRE_MAP = {
    // 🔥 Most Popular / Core Genres
    "fiction": "Fiction",
    "romance": "Romance",
    "fantasy": "Fantasy",
    "science-fiction": "Science Fiction",
    "mystery": "Mystery",
    "thriller": "Thriller",
    "horror": "Horror",
    "adventure": "Adventure",
    "drama": "Drama",
    "young-adult": "Young Adult",
    "childrens-literature": "Children's Literature",

    // 📚 Fiction Sub-genres
    "contemporary-fiction": "Contemporary Fiction",
    "literary-fiction": "Literary Fiction",
    "historical-fiction": "Historical Fiction",
    "urban-fiction": "Urban Fiction",
    "dystopian": "Dystopian",
    "magical-realism": "Magical Realism",
    "epic-fantasy": "Epic Fantasy",
    "high-fantasy": "High Fantasy",
    "dark-fantasy": "Dark Fantasy",
    "paranormal-romance": "Paranormal Romance",
    "supernatural": "Supernatural",
    "short-stories": "Short Stories",
    "flash-fiction": "Flash Fiction",

    // 🧠 Emotional / Thematic
    "psychological": "Psychological",
    "real-life": "Real-Life",
    "friendship": "Friendship",
    "empowerment": "Empowerment",
    "motivational": "Motivational",
    "modern-society": "Modern Society",
    "lifestyle": "Lifestyle",
    "dreams": "Dreams",

    // 😂 Light / Entertainment
    "comedy": "Comedy",
    "humor": "Humor",
    "satire": "Satire",

    // 🔍 Crime / Suspense
    "crime": "Crime",
    "true-crime": "True Crime",
    "psychological-thriller": "Psychological Thriller",

    // 🌍 Cultural / Identity
    "culture": "Culture",
    "african-myth": "African Myth",
    "african-proverbs": "African Proverbs",
    "folklore": "Folklore",
    "mythology": "Mythology",

    // 🏫 Settings / Story Types
    "campus-stories": "Campus Stories",
    "historical-tales": "Historical Tales",
    "war-and-military": "War & Military",
    "ghost-stories": "Ghost Stories",

    // 📖 Non-Fiction Core
    "non-fiction": "Non-Fiction",
    "biography": "Biography",
    "autobiography": "Autobiography",
    "memoir": "Memoir",

    // 💡 Self Development
    "self-help": "Self-Help",
    "personal-finance": "Personal Finance",
    "health-and-wellness": "Health & Wellness",
    "parenting": "Parenting",

    // 🧪 Knowledge / Academic
    "business": "Business",
    "technology": "Technology",
    "science": "Science",
    "education": "Education",
    "psychology": "Psychology",
    "philosophy": "Philosophy",
    "sociology": "Sociology",
    "politics": "Politics",

    // 🙏 Spiritual / Religious
    "spirituality": "Spirituality",
    "religion": "Religion",
    "faith": "Faith",

    // 🎨 Creative
    "art-and-photography": "Art & Photography",
    "music-and-art": "Music & Art",
    "poetry": "Poetry",
    "anthology": "Anthology",
    "graphic-novels": "Graphic Novels",

    // 🍳 Lifestyle & Hobby
    "cooking": "Cooking",
    "travel": "Travel",

    // 🚀 Sci-Fi Extensions
    "cyberpunk": "Cyberpunk",
    "post-apocalyptic": "Post-Apocalyptic",
    "space-opera": "Space Opera",

    // 🧩 Extras
    "fairy-tales": "Fairy Tales",
};

export const bookGenres = Object.values(GENRE_MAP);
export const BookGenreOptions = Object.entries(GENRE_MAP).map(([slug, name]) => ({ slug, name }))